/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Jadwal_S2Inputs */

const en_tut_jadwal_s2 = /** @type {(inputs: Tut_Jadwal_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To change the time, the host opens a meeting that has not started, presses **Ubah jadwal**, picks a new time, and presses **Simpan jadwal**.`)
};

const id_tut_jadwal_s2 = /** @type {(inputs: Tut_Jadwal_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk mengubah waktu, host membuka rapat yang belum dimulai, menekan **Ubah jadwal**, memilih waktu baru, lalu **Simpan jadwal**.`)
};

/**
* | output |
* | --- |
* | "To change the time, the host opens a meeting that has not started, presses **Ubah jadwal**, picks a new time, and presses **Simpan jadwal**." |
*
* @param {Tut_Jadwal_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_jadwal_s2 = /** @type {((inputs?: Tut_Jadwal_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Jadwal_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_jadwal_s2(inputs)
	return en_tut_jadwal_s2(inputs)
});